module.exports = __webpack_public_path__ + "static/media/ico_arrow_up_blue.4da8d5b0.svg";